import { defineRouter } from '#q-app';
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';

import { registerClientProfileRedirect } from 'src/composites/ClientProfile/routes';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const createHistory = import.meta.env.QUASAR_SERVER ? createMemoryHistory : import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory;

const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,

  /*
   * Leave this as is and make changes in quasar.conf.js instead!
   * quasar.conf.js -> build -> vueRouterMode
   * quasar.conf.js -> build -> publicPath
   */
  history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE)
});

registerClientProfileRedirect(Router);

export default defineRouter(function (/* { store, ssrContext } */) {
  return Router;
});

export { Router };
